import { render, staticRenderFns } from "./SensorDetails.vue?vue&type=template&id=1f9ab872&scoped=true&"
import script from "./SensorDetails.vue?vue&type=script&lang=js&"
export * from "./SensorDetails.vue?vue&type=script&lang=js&"
import style0 from "./SensorDetails.vue?vue&type=style&index=0&id=1f9ab872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ab872",
  null
  
)

export default component.exports